import { styled } from "@mui/material/styles";
import { colors } from '../../../theme/colors';
import { Box, Button, DialogContent, Typography } from "@mui/material";
import { Padding } from "@mui/icons-material";
import { pad } from "lodash";

export const StyledTitle = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  fontWeight: "bold",
  color: colors.primary,
  marginTop: "1.5rem"
}));

export const StyledSubTitle = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  color: colors.primary,
  textAlign: "center",
  marginTop: "1rem"
}));


export const StyledDialogContent = styled(DialogContent)({
    "& .MuiDialogTitle-root": {
    },
    "& .MuiDialogTitle-root + .MuiDialogContent-root": {
        padding: "60px",
    }
  });
  
export const StyledBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: "flex",
  justifyContent: "flex-end",
}));

export const StyledOutlinedButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(2),
  backgroundColor: "#fff",
  borderColor: colors.primary,
  color: colors.primary,
  "&:hover": {
    backgroundColor: "#fff",
    borderColor: colors.primary,
  },
}));

export const StyledContainedButton = styled(Button)(({ theme }) => ({
  backgroundColor: colors.primary,
  color: "#fff",
  "&:hover": {
    backgroundColor: colors.primaryHover,
    color: "#fff",
  },
}));
